// Message WhatsApp proposé après l'envoi d'un formulaire : une ligne de salutation,
// puis chaque champ rempli sous la forme « Libellé : valeur ». Rien n'est envoyé ni suivi ici :
// le lien ouvre simplement WhatsApp chez le visiteur.

export type LeadLine = readonly [label: string, value: string]

export function whatsappText(greeting: string, lines: readonly LeadLine[]): string {
  const filled = lines
    .map(([label, value]) => [label, value.trim()] as const)
    .filter(([, value]) => value)
    .map(([label, value]) => `${label} : ${value}`)
  return [greeting, '', ...filled].join('\n').trim()
}

export function whatsappLink(number: string, text: string): string {
  const digits = number.replace(/\D/g, '')
  return digits ? `https://wa.me/${digits}?text=${encodeURIComponent(text)}` : ''
}
